export const importTranslations = {
  import_title: 7891,
  import_number_of_errors: 7892,
  import_show_details: 7893,
  import_hide_details: 7916,
  import_status_successful: 7894,
  import_status_failed: 7895,
  import_status_pending: 7896,
  import_status: 7897,
  import_no_of_cases: 7898,
  import_no_of_ok_cases: 7901,
  import_no_of_failed_cases: 7899,
  import_date: 7900,
  import_load_date: 7902,
  import_file_name: 7903,
  import_cancel: 7904,
  import_submit: 7905,
  import_file_description: 7906,
  import_choose_file: 7907,
  import_set: 7908,
  import_file_to_synergi_life: 7909,
  import_add_to_import: 7910,
  import_retry: 7914,
  import_delete: 7915,
  import_delete_title: 7918,
  import_delete_desc: 7917,
  import_delete_success: 7934,
  import_edit_title: 7921,
  import_search_placeholder: 7557,
  import_success: 7922,
  import_retry_success: 7930,
  import_update_success: 7931,
  import_details_error: 7926,
  import_details_case_number: 7927,
  import_details_db: 7928,
  import_modal_wait: 7957,
  import_modal_done: 7958,
  no_imports: 7913,
  validation_error: 7702,
  must_be_filled: 5949,
  done: 7338
};

export const endpoint = {
  caseImport: 'case/import',
  retryImport:'case/import',
  updateImport:'case/import',
  deleteImport:'case/import',
  loadCaseImport: 'case/import',
  loadImportSetOptions: 'case/import/importset/options',
  loadEditImport: (importCase) => { return `case/import/${importCase}` }
};

export const form = {
  importset: 'importset',
  comments: 'comments'
};

export const importStatusPollingInterval = 5000;

export const itemsPerPage = 5;
